import { html } from '../../../../../../../shared/utils/html.ts';
import { CategoryLevel1_CODE } from '../../../../../../../shared/mps-shared/domain/category/types.ts';
import { MpsCategory } from '../../../../../../../shared/mps-shared/domain/category/accessor.ts';

export const CATEGORY_LEVEL1_NAME = 'sp_root_cate_code';

const getCategoryLabel = (code: string): string => {
  const labels: Record<string, string> = {
    [CategoryLevel1_CODE.GOODS]: '굿즈',
    [CategoryLevel1_CODE.HANDMADE]: '핸드메이드',
    [CategoryLevel1_CODE.BRAND_DEAL]: '브랜드딜',
    [CategoryLevel1_CODE.EBOOK]: '전자책',
  };

  return labels[code] ?? '올바르지 않은 카테고리';
};

export const selectCategoryLevel1s = (
  categories: MpsCategory[],
  selected_code?: CategoryLevel1_CODE,
  disabled = false,
  klass = '',
) => html`
  <select class="${klass}" name="${CATEGORY_LEVEL1_NAME}" ${disabled ? 'disabled' : ''}>
    <option value="">대 카테고리</option>
    ${categories
      .map(
        (category) =>
          `<option value="${category.getCode()}"${category.getCode() == selected_code ? ' selected' : ''}>${getCategoryLabel(category.getCode())}</option>`, // .code → .getCode(), .display_name → .getDisplayName()
      )
      .join('')}
  </select>
`;
